module.exports = __webpack_public_path__ + "static/img/IMG_20240405_184319.c13befd6.jpg";